import React, { useEffect } from 'react'
import { RouteObject, useNavigate, useRoutes } from 'react-router-dom'
import Login from '../pages/Login'
import Orders from '../pages/Orders'
import IndividualizationOverview from '../pages/individualization/IndividualizationOverview'
import CreateIndividualization from '../pages/individualization/CreateIndividualization'
import EditIndividualization from '../pages/individualization/EditIndividualization'
import DuplicateIndividualization from '../pages/individualization/DuplicateIndividualization'
import SettingsOverview from '../pages/settings/SettingsOverview'
import ButtonSettings from '../pages/settings/ButtonSettings'
import FontSettings from '../pages/settings/FontSettings'
import MediaSettings from '../pages/settings/MediaSettings'
import CategorySettings from '../pages/settings/CategorySettings'
import SubscriptionOverview from '../pages/subscription/SubscriptionOverview/SubscriptionOverview'
import SubscriptionLogin from '../pages/subscription/SubscriptionLogin'
import SubscriptionRegister from '../pages/subscription/SubscriptionRegister'
import SubscriptionPasswordReset from '../pages/subscription/SubscriptionPasswordReset'
import SubscriptionAdministration from '../pages/subscription/SubscriptionAdministration/SubscriptionAdministration'
import SubscriptionSubscribe from '../pages/subscription/SubscriptionSubscribe/SubscriptionSubscribe'
import SubscriptionChange from '../pages/subscription/SubscriptionChange/SubscriptionChange'
import SubscriptionCompanyChange from '../pages/subscription/SubscriptionCompanyChange'
import FulfillmentSettings from '../pages/settings/FulfillmentSettings'
import ProtectedRoute from './ProtectedRoute'
import FulfillmentOverview from '../pages/fulfillment/FulfillmentOverview'
import FulfillmentDetail from '../pages/fulfillment/FulfillmentDetail'
import FulfillmentOrder from '../pages/fulfillment/FulfillmentOrder'
import { useAuth } from '../contexts/AuthContext'
import UpdateSettings from '../pages/settings/UpdateSettings'
import AdvancedSettings from "../pages/settings/AdvancedSettings";

const Routes = () => {
    const { role } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        const orderId = params.get('order')
        const customizationId = params.get('customization')
        if (orderId) {
            navigate(`/fulfillment/orders/${orderId}`, { replace: true })
        }
        if (customizationId) {
            navigate(`/fulfillment/customizations/${customizationId}`, {
                replace: true,
            })
        }
    }, [])

    const routes: RouteObject[] = [
        {
            path: '/login',
            element: <Login />,
        },
        {
            path: '/',
            element:
                role === 'admin' ? (
                    <IndividualizationOverview />
                ) : role === 'fulfiller' ? (
                    <FulfillmentOverview />
                ) : (
                    <Login />
                ),
        },
        {
            element: <ProtectedRoute allowedRoles={['admin']} />,
            children: [
                {
                    path: '/individualizations',
                    element: <IndividualizationOverview />,
                },
                {
                    path: '/individualizations/create',
                    element: <CreateIndividualization />,
                },
                {
                    path: '/individualizations/create/:step',
                    element: <CreateIndividualization />,
                },
                {
                    path: '/individualizations/:id/edit',
                    element: <EditIndividualization />,
                },
                {
                    path: '/individualizations/:id/edit/:step',
                    element: <EditIndividualization />,
                },
                {
                    path: '/individualizations/:id/copy',
                    element: <DuplicateIndividualization />,
                },
                {
                    path: '/individualizations/:id/copy/:step',
                    element: <DuplicateIndividualization />,
                },
                {
                    path: '/orders',
                    element: <Orders />,
                },
                {
                    path: '/settings',
                    element: <SettingsOverview />,
                },
                {
                    path: '/settings/overview',
                    element: <SettingsOverview />,
                },
                {
                    path: '/settings/button',
                    element: <ButtonSettings />,
                },
                {
                    path: '/settings/fonts',
                    element: <FontSettings />,
                },
                {
                    path: '/settings/media',
                    element: <MediaSettings />,
                },
                {
                    path: '/settings/media-categories',
                    element: <CategorySettings />,
                },
                {
                    path: '/settings/fulfillment',
                    element: <FulfillmentSettings />,
                },
                {
                    path: '/settings/update',
                    element: <UpdateSettings />,
                },
                {
                    path: '/settings/advanced',
                    element: <AdvancedSettings />,
                },
                {
                    path: '/subscription',
                    element: <SubscriptionOverview />,
                },
                {
                    path: '/subscription/admin',
                    element: <SubscriptionAdministration />,
                },
                {
                    path: '/subscription/login',
                    element: <SubscriptionLogin />,
                },
                {
                    path: '/subscription/register',
                    element: <SubscriptionRegister />,
                },
                {
                    path: '/subscription/password-reset',
                    element: <SubscriptionPasswordReset />,
                },
                {
                    path: '/subscription/subscribe',
                    element: <SubscriptionSubscribe />,
                },
                {
                    path: '/subscription/change-plan',
                    element: <SubscriptionChange />,
                },
                {
                    path: '/subscription/change-company',
                    element: <SubscriptionCompanyChange />,
                },
            ],
        },
        {
            element: <ProtectedRoute allowedRoles={['fulfiller', 'admin']} />,
            children: [
                {
                    path: '/fulfillment',
                    element: <FulfillmentOverview />,
                },
                {
                    path: '/fulfillment/customizations/:id',
                    element: <FulfillmentDetail />,
                },
                {
                    path: '/fulfillment/orders/:id',
                    element: <FulfillmentOrder />,
                },
            ],
        },
    ]

    return useRoutes(routes)
}

export default Routes
